var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Stack, Typography, FormControl, FormLabel, Input, Button, Box, IconButton, Modal, ModalDialog, ModalClose, DialogTitle, DialogContent, useColorScheme, Dropdown, MenuButton, Menu, MenuItem, Textarea, } from "@mui/joy";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { useContactGroups } from "../../../data/hooks/useContactGroups";
import MoreVert from "@mui/icons-material/MoreVert";
import NotificationSnackbars from "../../../components/ui/NotificationSnackbars";
import TextMaskAdapter from "../../../components/ui/MaskTextInput";
var ActionDropdown = function (_a) {
    var contact = _a.contact, onDelete = _a.onDelete, onEdit = _a.onEdit;
    return (_jsxs(Dropdown, { children: [_jsx(MenuButton, __assign({ slots: { root: IconButton }, slotProps: { root: { variant: "plain", color: "neutral" } } }, { children: _jsx(MoreVert, {}) })), _jsxs(Menu, __assign({ placement: "bottom-end", size: "sm" }, { children: [_jsxs(MenuItem, __assign({ onClick: function () { return onEdit(contact); } }, { children: [_jsx(EditIcon, { sx: { mr: 1 } }), "Edit"] })), _jsxs(MenuItem, __assign({ onClick: function () { return onDelete(contact.id); }, variant: "soft", color: "danger" }, { children: [_jsx(DeleteIcon, { sx: { mr: 1 } }), "Delete"] }))] }))] }));
};
export var AddEditContactGroup = function () {
    // figure out if we're creating or editing
    var groupId = useParams().groupId;
    var navigate = useNavigate();
    var isEditing = !!groupId;
    var mode = useColorScheme().mode;
    var _a = useState(false), darkMode = _a[0], setDarkMode = _a[1];
    useEffect(function () {
        setDarkMode(mode === "dark");
    }, [mode]);
    var _b = useContactGroups(), getContactGroupById = _b.getContactGroupById, createContactGroup = _b.createContactGroup, updateContactGroup = _b.updateContactGroup, getAllContactGroups = _b.getAllContactGroups;
    // Initial form state
    var _c = useState({
        id: 0,
        name: "",
        description: "",
        contacts: [],
        customFieldDefinitions: {}, // ensure we have a dictionary
    }), groupForm = _c[0], setGroupForm = _c[1];
    // Loading/error states
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(null), errorMessage = _e[0], setErrorMessage = _e[1];
    var _f = useState(null), successMessage = _f[0], setSuccessMessage = _f[1];
    // Contact modal (for add/edit)
    var _g = useState(false), openContactModal = _g[0], setOpenContactModal = _g[1];
    var _h = useState(null), editContactData = _h[0], setEditContactData = _h[1];
    // Custom fields modal
    var _j = useState(false), openCustomFieldsModal = _j[0], setOpenCustomFieldsModal = _j[1];
    // Convert the dictionary to an array for easier management in the UI
    var _k = useState([]), contactCustomFields = _k[0], setContactCustomFields = _k[1];
    // -------------------- LOAD GROUP IF EDITING --------------------
    useEffect(function () {
        function loadGroup(id) {
            return __awaiter(this, void 0, void 0, function () {
                var freshGroup, arr, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setLoading(true);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, getContactGroupById(id)];
                        case 2:
                            freshGroup = _a.sent();
                            if (freshGroup) {
                                setGroupForm(freshGroup);
                                arr = Object.entries(freshGroup.customFieldDefinitions || {}).map(function (_a) {
                                    var k = _a[0], v = _a[1];
                                    return ({
                                        key: k,
                                        label: v,
                                    });
                                });
                                setContactCustomFields(arr);
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _a.sent();
                            console.error("Error loading contact group:", error_1);
                            setErrorMessage("Error loading contact group details.");
                            return [3 /*break*/, 4];
                        case 4:
                            setLoading(false);
                            return [2 /*return*/];
                    }
                });
            });
        }
        if (isEditing && groupId) {
            loadGroup(parseInt(groupId, 10));
        }
    }, [isEditing, groupId]);
    // -------------------- SAVE GROUP --------------------
    var handleSaveGroup = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newId, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setErrorMessage(null);
                    setSuccessMessage(null);
                    if (!groupForm.name) {
                        setErrorMessage("Group name is required.");
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 8, , 9]);
                    if (!!isEditing) return [3 /*break*/, 4];
                    return [4 /*yield*/, createContactGroup(groupForm)];
                case 2:
                    newId = _a.sent();
                    setSuccessMessage("Contact Group #".concat(newId, " created successfully."));
                    // navigate away
                    return [4 /*yield*/, getAllContactGroups()];
                case 3:
                    // navigate away
                    _a.sent();
                    navigate("/contact-groups");
                    return [3 /*break*/, 7];
                case 4: 
                // UPDATE
                return [4 /*yield*/, updateContactGroup(Number(groupId), groupForm)];
                case 5:
                    // UPDATE
                    _a.sent();
                    setSuccessMessage("Contact Group #".concat(groupForm.id, " updated successfully."));
                    return [4 /*yield*/, getAllContactGroups()];
                case 6:
                    _a.sent();
                    navigate("/contact-groups");
                    _a.label = 7;
                case 7: return [3 /*break*/, 9];
                case 8:
                    error_2 = _a.sent();
                    setErrorMessage(error_2.message || "Failed to save contact group.");
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    // -------------------- ADD CONTACT --------------------
    var handleAddClick = function () {
        setEditContactData({
            index: -1,
            contact: {
                id: 0,
                name: "",
                phoneNumber: "",
                email: "",
                note: "",
                // For custom fields
                additionalData: {},
            },
            isNew: true,
        });
        setOpenContactModal(true);
    };
    // -------------------- EDIT CONTACT --------------------
    var handleEditClick = useCallback(function (contact) {
        var index = groupForm.contacts.findIndex(function (c) { return c.id === contact.id; });
        if (index === -1) {
            console.error("Contact not found for editing:", contact.id);
            return;
        }
        setEditContactData({
            index: index,
            contact: __assign({}, contact),
            isNew: false,
        });
        setOpenContactModal(true);
    }, [groupForm]);
    // -------------------- DELETE CONTACT --------------------
    var handleDeleteContact = useCallback(function (contactId) {
        if (!window.confirm("Are you sure you want to delete this contact?")) {
            return;
        }
        setGroupForm(function (prev) { return (__assign(__assign({}, prev), { contacts: prev.contacts.filter(function (c) { return c.id !== contactId; }) })); });
    }, []);
    // -------------------- AG-Grid ColDefs --------------------
    var defaultColDef = useMemo(function () { return ({
        filter: true,
        resizable: true,
    }); }, []);
    var columnDefs = useMemo(function () { return [
        { headerName: "Name", field: "name", flex: 1 },
        { headerName: "Phone", field: "phoneNumber", flex: 1 },
        { headerName: "Email", field: "email", flex: 1 },
        { headerName: "Note", field: "note", flex: 1 },
        {
            headerName: "Actions",
            field: "actions",
            maxWidth: 80,
            sortable: false,
            filter: false,
            cellRenderer: function (params) { return (_jsx(Box, __assign({ sx: {
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    justifyContent: "center",
                } }, { children: _jsx(ActionDropdown, { contact: params.data, onDelete: handleDeleteContact, onEdit: handleEditClick }) }))); },
        },
    ]; }, [handleEditClick, handleDeleteContact]);
    // -------------------- CONTACT MODAL: SAVE --------------------
    var handleSaveContactModal = function () {
        if (!editContactData)
            return;
        var index = editContactData.index, contact = editContactData.contact, isNew = editContactData.isNew;
        if (!contact.name) {
            setErrorMessage("Contact name is required.");
            return;
        }
        if (!contact.phoneNumber) {
            setErrorMessage("Contact phone number is required.");
            return;
        }
        // Merge into groupForm
        setGroupForm(function (prev) {
            var updatedContacts = __spreadArray([], prev.contacts, true);
            if (isNew) {
                updatedContacts.push(contact);
            }
            else {
                updatedContacts[index] = contact;
            }
            return __assign(__assign({}, prev), { contacts: updatedContacts });
        });
        setOpenContactModal(false);
        setEditContactData(null);
    };
    var handleCloseContactModal = function () {
        setOpenContactModal(false);
        setEditContactData(null);
    };
    // -------------------- CUSTOM FIELDS MODAL: HANDLING --------------------
    // Whenever the user changes the array, rebuild the dictionary in groupForm
    var handleCustomFieldsChange = function (fieldsArr) {
        setContactCustomFields(fieldsArr);
        var newDict = {};
        fieldsArr.forEach(function (_a) {
            var key = _a.key, label = _a.label;
            if (key.trim() !== "") {
                newDict[key.trim()] = label || "";
            }
        });
        setGroupForm(function (prev) { return (__assign(__assign({}, prev), { customFieldDefinitions: newDict })); });
    };
    var handleAddCustomField = function () {
        setContactCustomFields(function (prev) { return __spreadArray(__spreadArray([], prev, true), [{ key: "", label: "" }], false); });
    };
    var handleRemoveCustomField = function (idx) {
        var updated = contactCustomFields.filter(function (_, i) { return i !== idx; });
        handleCustomFieldsChange(updated);
    };
    var handleCloseCustomFieldsModal = function () {
        setOpenCustomFieldsModal(false);
    };
    // -------------------- Render --------------------
    return (_jsxs(Stack, __assign({ direction: "column", spacing: 2, sx: {
            width: "100%",
            height: "100%",
            overflowY: "auto",
        } }, { children: [_jsx(Stack, __assign({ direction: "row", justifyContent: "space-between", alignItems: "center", sx: { px: 2 } }, { children: _jsx(Typography, __assign({ sx: { mt: 2 }, level: "h2", component: "h1" }, { children: isEditing ? "Edit Contact Group" : "Create Contact Group" })) })), _jsx(NotificationSnackbars, { errorMessage: errorMessage, successMessage: successMessage, setErrorMessage: setErrorMessage, setSuccessMessage: setSuccessMessage }), loading ? (_jsx(_Fragment, { children: _jsx(Box, { children: "Loading..." }) })) : (_jsxs(Stack, __assign({ sx: { px: 2, width: "100%", height: "100%" } }, { children: [_jsx(Stack, __assign({ spacing: 2, direction: "row" }, { children: _jsxs(FormControl, __assign({ sx: { mt: 1, flex: 1 } }, { children: [_jsx(FormLabel, { children: "Group Name" }), _jsx(Input, { placeholder: "E.g. VIP Customers", value: groupForm.name, size: "sm", onChange: function (e) { return setGroupForm(__assign(__assign({}, groupForm), { name: e.target.value })); } })] })) })), _jsxs(FormControl, __assign({ sx: { mt: 1, mb: 1 } }, { children: [_jsx(FormLabel, { children: "Description" }), _jsx(Textarea, { placeholder: "E.g. High-value clients...", value: groupForm.description || "", size: "sm", onChange: function (e) { return setGroupForm(__assign(__assign({}, groupForm), { description: e.target.value })); } })] })), _jsx(Button, __assign({ variant: "soft", size: "sm", startDecorator: _jsx(AddIcon, {}), onClick: function () { return setOpenCustomFieldsModal(true); }, sx: { alignSelf: "flex-start", mt: 1 } }, { children: "Manage Custom Fields for Contacts" })), _jsxs(Stack, __assign({ direction: "row", justifyContent: "space-between", alignItems: "center", sx: { mt: 3, mb: 1 } }, { children: [_jsx(Typography, __assign({ level: "title-lg" }, { children: "Contacts" })), _jsx(Button, __assign({ variant: "soft", size: "sm", startDecorator: _jsx(AddIcon, {}), onClick: handleAddClick }, { children: "Add Contact" }))] })), _jsx(Box, __assign({ sx: {
                            mt: 1,
                            width: "100%",
                            height: "100%",
                        }, className: darkMode ? "ag-theme-quartz-dark" : "ag-theme-quartz" }, { children: _jsx(AgGridReact, { rowData: groupForm.contacts, columnDefs: columnDefs, defaultColDef: defaultColDef, pagination: true, enableCellTextSelection: true }) })), _jsxs(Stack, __assign({ direction: "row", justifyContent: "flex-end", spacing: 2, sx: { mb: 2, mt: 2 } }, { children: [_jsx(Button, __assign({ variant: "outlined", size: "sm", onClick: function () { return navigate("/contact-groups"); } }, { children: "Cancel" })), _jsx(Button, __assign({ variant: "solid", color: "primary", onClick: handleSaveGroup }, { children: isEditing ? "Update Group" : "Create Group" }))] }))] }))), _jsx(Modal, __assign({ open: openContactModal, onClose: handleCloseContactModal, hideBackdrop: true }, { children: _jsxs(ModalDialog, __assign({ variant: "outlined", size: "md", layout: "center" }, { children: [_jsx(ModalClose, {}), _jsx(DialogTitle, { children: (editContactData === null || editContactData === void 0 ? void 0 : editContactData.isNew) ? "Add Contact" : "Edit Contact" }), _jsx(DialogContent, { children: editContactData && (_jsxs(Stack, __assign({ spacing: 2 }, { children: [_jsxs(FormControl, { children: [_jsx(FormLabel, { children: "Name" }), _jsx(Input, { value: editContactData.contact.name, onChange: function (e) {
                                                    return setEditContactData(function (prev) {
                                                        return prev
                                                            ? __assign(__assign({}, prev), { contact: __assign(__assign({}, prev.contact), { name: e.target.value }) }) : null;
                                                    });
                                                } })] }), _jsxs(FormControl, { children: [_jsx(FormLabel, { children: "Phone Number" }), _jsx(Input, { value: editContactData.contact.phoneNumber, size: "sm", onChange: function (e) {
                                                    return setEditContactData(function (prev) {
                                                        return prev
                                                            ? __assign(__assign({}, prev), { contact: __assign(__assign({}, prev.contact), { phoneNumber: e.target.value }) }) : null;
                                                    });
                                                }, placeholder: "+1234567890", slotProps: { input: { component: TextMaskAdapter } } })] }), _jsxs(FormControl, { children: [_jsx(FormLabel, { children: "Email" }), _jsx(Input, { value: editContactData.contact.email || "", onChange: function (e) {
                                                    return setEditContactData(function (prev) {
                                                        return prev
                                                            ? __assign(__assign({}, prev), { contact: __assign(__assign({}, prev.contact), { email: e.target.value }) }) : null;
                                                    });
                                                } })] }), _jsxs(FormControl, { children: [_jsx(FormLabel, { children: "Note" }), _jsx(Textarea, { value: editContactData.contact.note || "", onChange: function (e) {
                                                    return setEditContactData(function (prev) {
                                                        return prev
                                                            ? __assign(__assign({}, prev), { contact: __assign(__assign({}, prev.contact), { note: e.target.value }) }) : null;
                                                    });
                                                } })] }), _jsx(Typography, __assign({ level: "title-sm", sx: { mt: 2 } }, { children: "Custom Fields" })), Object.entries(groupForm.customFieldDefinitions || {}).map(function (_a) {
                                        var _b;
                                        var fieldKey = _a[0], fieldLabel = _a[1];
                                        return (_jsxs(FormControl, __assign({ sx: { mb: 1 } }, { children: [_jsx(FormLabel, { children: fieldLabel }), _jsx(Input
                                                // The contact's current value for that field:
                                                , { 
                                                    // The contact's current value for that field:
                                                    value: ((_b = editContactData.contact.additionalData) === null || _b === void 0 ? void 0 : _b[fieldKey]) || "", onChange: function (e) {
                                                        return setEditContactData(function (prev) {
                                                            var _a;
                                                            return prev
                                                                ? __assign(__assign({}, prev), { contact: __assign(__assign({}, prev.contact), { additionalData: __assign(__assign({}, prev.contact.additionalData), (_a = {}, _a[fieldKey] = e.target.value, _a)) }) }) : null;
                                                        });
                                                    } })] }), fieldKey));
                                    }), _jsxs(Stack, __assign({ direction: "row", justifyContent: "flex-end", spacing: 2, mt: 2 }, { children: [_jsx(Button, __assign({ variant: "plain", onClick: handleCloseContactModal }, { children: "Cancel" })), _jsx(Button, __assign({ variant: "solid", color: "primary", onClick: handleSaveContactModal }, { children: editContactData.isNew ? "Add" : "Save" }))] }))] }))) })] })) })), _jsx(Modal, __assign({ open: openCustomFieldsModal, onClose: handleCloseCustomFieldsModal, hideBackdrop: true }, { children: _jsxs(ModalDialog, __assign({ variant: "outlined", size: "md", layout: "center" }, { children: [_jsx(ModalClose, {}), _jsx(DialogTitle, { children: "Manage Custom Fields for Contacts" }), _jsxs(DialogContent, { children: [_jsxs(Stack, __assign({ spacing: 1, sx: { mt: 1 } }, { children: [contactCustomFields.map(function (field, idx) { return (_jsxs(Stack, __assign({ direction: "row", spacing: 1 }, { children: [_jsx(Input, { placeholder: "Field Key (e.g. ServiceProvider)", value: field.key, onChange: function (e) {
                                                        var newKey = e.target.value;
                                                        var newArr = __spreadArray([], contactCustomFields, true);
                                                        newArr[idx] = __assign(__assign({}, newArr[idx]), { key: newKey });
                                                        handleCustomFieldsChange(newArr);
                                                    }, size: "sm" }), _jsx(Input, { placeholder: "Label (e.g. 'Service Provider')", value: field.label, onChange: function (e) {
                                                        var newLabel = e.target.value;
                                                        var newArr = __spreadArray([], contactCustomFields, true);
                                                        newArr[idx] = __assign(__assign({}, newArr[idx]), { label: newLabel });
                                                        handleCustomFieldsChange(newArr);
                                                    }, size: "sm" }), _jsx(IconButton, __assign({ variant: "plain", onClick: function () { return handleRemoveCustomField(idx); } }, { children: _jsx(DeleteIcon, {}) }))] }), idx)); }), _jsx(Button, __assign({ variant: "soft", size: "sm", startDecorator: _jsx(AddIcon, {}), onClick: handleAddCustomField, sx: { alignSelf: "flex-start", mt: 1 } }, { children: "Add Field Definition" }))] })), _jsx(Stack, __assign({ direction: "row", justifyContent: "flex-end", spacing: 2, mt: 3 }, { children: _jsx(Button, __assign({ variant: "plain", onClick: handleCloseCustomFieldsModal }, { children: "Done" })) }))] })] })) }))] })));
};
